import React, { Fragment } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import getImageUrl from 'utils/getImageUrl'
import ErrorBoundary from 'components/errorBoundary'
import MediaPlayer from './MediaPlayer'

const VideoCourse = ({ courseDetail: { introVideo = '', coverImageVideo } }) => {
  return (
    <ErrorBoundary>
      <Fragment>
        <MediaPlayer
          light={getImageUrl(coverImageVideo)}
          url={introVideo}
          isShowVideoWidth={false}
        />
      </Fragment>
    </ErrorBoundary>
  )
}

VideoCourse.propTypes = {
  introVideo: PropTypes.string.isRequired,
}

const mapState = ({ Course: { courseDetail } }) => ({ courseDetail })

export default connect(mapState, null)(VideoCourse)
